// extracted by mini-css-extract-plugin
module.exports = {"centerText":"InitialLoad_centerText__28SXl"};